import * as React from "react";
import { connect } from "react-redux";
import { Container, Dropdown, Accordion, Card, Button ,Form,Spinner,} from "react-bootstrap";

import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { BankService } from "../../Common/Services/BankService";
import  BankMasterSlidout  from "../../Modules/Masters/BankMasterSlidout";

import paginationFactory from 'react-bootstrap-table2-paginator';

import _ from "lodash";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
const { SearchBar } = Search;

  
 class BankMaster extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
         
          htmlItem: [],
          htmlErrorItem: [],
          htmlWarningItem: [],
          searcResult: [],
          bankId:0,
          selectedcolumn: "All",
          selectOptions: [
            { id: 'All', name: 'All'},
            { id: 'Bank Name', name: 'Bank Name' },
            { id: 'Account Type', name: 'Account Type' },
            { id: 'Phone Number', name: 'Phone Number' },
            { id: 'Email', name: 'Email' },

          ],
        };
        
     
      }
      componentDidMount() {
        let requestlist = { ...this.state.requestlist };
        this.getBankMaster(requestlist);
      }

      componentDidUpdate(prevProps) {
        if (prevProps.locationId != this.props.locationId && !this.state.showSlideout) {
            let requestlist = { ...this.state.requestlist };
            this.getBankMaster(requestlist);
        }
      }

      handleSelectedItem1 = (control: any, id: any) => {
        let searcResult1 = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.searcResult))
        );
    
        let chkisbankname = id == "Bank Name" ? true : false;
        let chkisaccounttype = id == "Account Type" ? true : false;
        let chkisPhoneNumber = id == "Phone Number" ? true : false;
        let chkisemail= id == "Email" ? true : false;
    
    
        if (id == "All") {
          chkisemail = true;
          chkisbankname = true;
          chkisaccounttype = true;
          chkisPhoneNumber = true;
    
        }
    
    
        this.setState({
          searcResult: [], selectedcolumn: id, isphone_number: chkisPhoneNumber, isemail: chkisemail,
          isbankname: chkisbankname, isaccounttype: chkisaccounttype
        },
          () => {
            this.setState({ searcResult: searcResult1 });    
          }
    
    
        );
    
      };


 
      getBankMaster = (requestlist: any) => {
 

        BankService.GetBanks({isBank:true})
    .then(async (result: any[] | null) => {
        
      if (result != null) {
        
        this.setState({ searcResult: result }, () => {
           
        });
      }
      resolve();
    })
    .catch((err: any) => {
      toast.error(`Server Error, ${err}`);
      reject();
    });  
  };

  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      this.setState({ showSlideout: true ,bankId:row.id,isSpinner:false});  
    },
  };
  
  showNewSlideOut = () => {
    this.setState({ showSlideout: true ,bankId:0,isSpinner:false});  
  };

  closeSlideOut = () => {
    this.setState({ showSlideout: false, isSpinner:false, });
    let requestlist = { ...this.state.requestlist };
    this.getBankMaster(requestlist);
};


  render() {
    const { permissions } = this.props; 
    const hasAddPermission = permissions && permissions['Bank Master'] ? permissions['Bank Master'].includes('Add Bank') : false;
    
    const {
      
      showSlideout,
      
  } = this.state;

  const columns = [

     {
      
      searchable: this.state.isaccounttype,
      dataField: 'lastAccountNo',
      text: 'Account No',
      sort: true,
    },
    {
      searchable: this.state.isbankname,
      dataField: 'bankName',
      text: 'Bank Name',

         formatter: (cell: any, row: any, rowIndex: any) => {       
      
 if(row.sharingid!=0)
 {
          return (
            <div>
              {row.bankName}
             
              {row.status}  <span className="badge badge-pill badge-primary color-green"> 
                Shared Bank </span>
             
            </div>
          );
 }
 else
 {
 return (
            <div>
              {row.bankName}
        
             
            </div>
          );

 }
}
    
    },
   
    {
      
      searchable: this.state.isaccounttype,
      dataField: 'accountType',
      text: 'Account Type',
      sort: true,
    },
    { 
      searchable: this.state.isphone_number,
      dataField: 'phone',
      text: 'Phone Number',
    },
    
    
    { 
      searchable: this.state.isemail,
      dataField: 'email',
      text: 'Email',
    },

{

  dataField: '',
        text: '',
          formatter: (cell: any, row: any, rowIndex: any) => {       
      
 if(row.status=="Inactive")
 {
          return (
            <div>
              <h6>
              <span className="badge badge-pill badge-primary color-red"> 
                Inactive </span>
              </h6>
            </div>
          );
 }
 else
 {

   return (
            <div>
              <h6>
             <span className="badge badge-pill badge-primary color-green"> 
                Active </span>
              </h6>
            </div>
          );
 }
},


}

      
      
  
 
      
      
    
     
  ];

    return (
      <>
        <React.Fragment>



          <Container fluid className="body-sec">
            <div className="page-heading underline d-flex">

            Bank Master
              <div className="action-group d-flex flex-row ml-auto">
                {hasAddPermission && <Button onClick={this.showNewSlideOut}>Add Bank</Button>}
              </div>
            </div>
            <section className="mt-3">
            <ToolkitProvider
        keyField="id"
        data={this.state.searcResult}
        columns={columns}

         //className="table table-striped table-borderless align-middle"
        search
      >
        {
          props => (


            <div >
              <section className="d-flex flex-wrap gap-3 pb-2">
                <div className="position-relative">
                  <SearchBar {...props.searchProps} />
                </div>

                <div  className="col-12 col-md-2"
>
                    <SingleDropdownListWithoutSearch
                      
                      itemList={this.state.selectOptions}
                      handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                      defaultItem={this.state.selectedcolumn}
                      defaultText={"Select Filter"}
                      defaultName={this.state.selectedcolumn}
                      controlID="1"
                      id={"ddlselected"}

                    />
                </div>

              </section>
              <section className="pb-3">
                <div className="table-responsive divbottom"  >
                  <div className="ml-auto transactions-list payroll-tbl1">
                  <BootstrapTable
                    {...props.baseProps}
                    rowEvents={this.rowEvents}
                    keyField="id"
                  

                  />
                  </div>
                </div>
            

              </section>
            </div>

          )
        }
 </ToolkitProvider>
 </section>
{(showSlideout &&

<BankMasterSlidout
closeSlideOut={this.closeSlideOut}
bankId={this.state.bankId}
>


</BankMasterSlidout>)}





          </Container>



        </React.Fragment>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
    permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId  
});

export default connect(mapStateToProps)(BankMaster);